import { useNavigate } from 'react-router-dom';

import { Button, Stack, Typography, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { useAuthenticator } from '@aws-amplify/ui-react';

import LogoImage from '../../assets/logo.png';
import LogoImageWebp from '../../assets/logo.webp';
import LogoMobileImage from '../../assets/logomobile.png';
import LogoMobileImageWebp from '../../assets/logomobile.webp';
import ImageWithFallback from '../../components/image/ImageWithFallback';
import logo from '../../assets/new_logo_web.jpg';

const LogoSection = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const handleClick = () => {
    if (authStatus != 'authenticated'){
      navigate('/public')
    }
    else{
      navigate('/app')
    }
  }
  return (
    <>
      <Box sx={{ display: { xs: 'none', sm: 'block'} }}>
        <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={-2}>
          <Button disableRipple onClick={handleClick} >
            <img src={logo} alt="INSITE Logo" style={{ height: '50px', width: '100px'}} />
          </Button>
        </Stack>
      </Box>
    </>
  );
};

export default LogoSection;
